export * from './name.controller';
import sensorName from './sensorName.html';

export { sensorName }
